import { Link } from "@heroui/react";
import { SiDiscord } from "@icons-pack/react-simple-icons";

import { DISCORD_INVITE } from "../../../lib/constants";
import { Button } from "../../core/Button";

export const DiscordButton = () => {
  return (
    <Button
      as={Link}
      size="sm"
      href={DISCORD_INVITE}
      target="_blank"
      variant="ghost"
    >
      <SiDiscord size={18} />
      <p>Discord</p>
    </Button>
  );
};
